import slugify from "slugify";

export default function FormSingleCheckbox({
  label,
  required = false,
  error = false,
  description,
  ...params
}) {
  const identifier = slugify(label);
  return (
    <fieldset className="FormInput">
      <div className="Options">
        <div className="OptionInput">
          <input id={identifier} type="checkbox" {...params} />
          <label htmlFor={identifier}>{label}</label>
        </div>
      </div>
      {description && <p className="FormDescription">{description}</p>}
    </fieldset>
  );
}
